// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_iwuza","avatar":"index_avatar_2lpiY","menuIcon":"index_menuIcon_VpvxC"};